import axios from "axios";
class ApiRegion {
    static async GetRegions() {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") +
                "api/web-api/public/regions/get-regions", {});
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get regions");
        }
    }
    static async GetRegionByUUID(regionUUID) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") +
                "api/web-api/public/regions/get-region-by", { uuid: regionUUID });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get region");
        }
    }
    static async CreateRegion(session_uuid, data) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") + "api/admin/regions/create-region", {
                facility_id: data.facility_id,
                name: data.name,
                region_name: data.region_name,
                is_active: data.is_active,
                mnp_enabled: data.mnp_enabled,
                order: data.order,
                delivery: data.delivery,
                cdek_point: data.cdek_point || "MSK108",
                iso_code: data.iso_code,
                latitude: data.latitude,
                longitude: data.longitude
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data.region_uuid;
        }
        catch (e) {
            console.log("Error create region");
            return null;
        }
    }
    static async UpdateRegion(session_uuid, regionUUID, data) {
        try {
            const result = await axios.put((process.env.VUE_APP_API_PATH || "/") + "api/admin/regions/update-region", {
                uuid: regionUUID,
                facility_id: data.facility_id,
                name: data.name,
                region_name: data.region_name,
                is_active: data.is_active,
                mnp_enabled: Number(data.mnp_enabled) || 0,
                order: data.order,
                delivery: data.delivery,
                cdek_point: data.cdek_point || "MSK108",
                iso_code: data.iso_code,
                latitude: data.latitude,
                longitude: data.longitude
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.status;
        }
        catch (e) {
            console.log("Error update region");
            return false;
        }
    }
    static async DeleteRegion(session_uuid, regionUUID) {
        try {
            const result = await axios.request({
                method: 'delete',
                url: (process.env.VUE_APP_API_PATH || "/") + "api/admin/regions/delete-region",
                data: { uuid: regionUUID },
                headers: { "x-tenant": "null", "x-session-token": session_uuid },
            });
            return result.data.data;
        }
        catch (e) {
            console.log("Error delete region");
            return;
        }
    }
    static async UpdateRegionActivity(is_active, session_uuid, uuid) {
        console.log("is_active ", is_active);
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") +
                "api/admin/regions/change-activity", {
                uuid: uuid,
                is_active: is_active,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async GetEMSFacilities(session_uuid) {
        try {
            const result = await axios.get((process.env.VUE_APP_API_PATH || "/") +
                "api/admin/get-ems-facilities", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get facilities");
        }
    }
    static async GuessCoordinates(session_uuid, city) {
        try {
            const result = await axios.post((process.env.VUE_APP_API_PATH || "/") +
                "api/admin/regions/get-dadata", { query: city }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data[0];
        }
        catch (e) {
            throw new Error("Error guess coordinates");
        }
    }
}
export default ApiRegion;
